/* underscoreCase() is a helper method and
 * transform string camelCase into underscore_case
 * e.g fooBar to foo_bar
*/
const underscoreCase = function(str) {
  return str.replace(/([a-z])([A-Z]+)/g, function(terms) {
    return terms[0] + '_' + terms[1].toLowerCase();
  });
};

/* underscorifyObject() is a helper method and
 * transform Object with camelCased key into underscore_case key
 * e.g { fooBar: true } to { foo_bar: true }
 */

const isObject = (value) => value != null && (typeof value == 'object' || typeof value == 'function');

const underscorifyObject = function(object) {
  return Object.keys(object || {}).reduce(function(memo, key) {
    const value = object[key];
    const newValue = isObject(value) ? underscorifyObject(value) : value;
    memo[underscoreCase(key)] = newValue;
    return memo;
  }, {});
};

/* underscorify() exposes single API and
 * will transform either string type or object type
 */

const underscorify = function(param) {
  switch (typeof param) {
    case 'string':
      return underscoreCase(param);
    case 'object':
      return underscorifyObject(param);
    default:
      return param;
  }
};

export default underscorify;
